import React, { Suspense } from 'react';
import LoadData from './Views/LoadData';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import PublicPage from './Views/Public/PublicPage';
import { defaultUserObj, UserLoggedInContextProvider} from "./ContextAndHOC/LoggedInContext";
import refreshTokens from "./ContextAndHOC/RefreshTokens";
import countDownTimer from './components/timeout';
import themeCalculator from './ThemeFile';
import { MuiThemeProvider} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import axios from 'axios';

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config:{},
      userDetails:defaultUserObj,
      changeUser: this.changeUser,
      userTimer: countDownTimer(),
      refreshTokens:refreshTokens(),
    };
  }
  changeUser = async (userObj) => {
    if (userObj) {
      this.setState({ userDetails: userObj });
    } else {
      this.logout();
      this.setState({ userDetails: defaultUserObj });
    }
  };

  logout = async()=>{
      axios({
        method: "post",
        url: '/api/content/providerauthservice/signout',
        headers: {'x-access-token':`${localStorage.getItem('accessToken')}`}
    });
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  };
  async componentDidMount() {
    let result = await axios.get('/api/content/providerauthservice/getconfig');
    if (result.data) {
      this.setState({ config: result.data });
    }
  }
  render() {
  return (
    <div style={{background:'#f3f4f5'}}>
     {this.state.config.title==="MyHOPE" ?<MuiThemeProvider theme={themeCalculator(this.state.config)}>
      <CssBaseline/>
      <UserLoggedInContextProvider value={this.state}>
      <BrowserRouter>
        <Switch basename = {process.env.PUBLIC_URL}>
          <Route path="/guest" component={PublicPage}/>
          <Route path="/Home" component={LoadData}/>
          <Redirect to = '/guest'/>
        </Switch>
      </BrowserRouter>
      </UserLoggedInContextProvider>
      </MuiThemeProvider>:""}
    </div>
  );
}
}

export default App;